export default class TemplateMeta {
	theme_file_name;
	plugin_template;

	constructor(meta) {
		this.theme_file_name = meta.theme_file_name;
		this.plugin_template = meta.plugin_template;
	}
}